var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.shouldShowBadge)?_c('Badge',{class:{ 'burn-countdown': true, burned: _vm.isBurned },attrs:{"background-color":_vm.backgroundColor || (_vm.isBurned ? `accentRedDark` : `grayDarkest`),"color":_vm.color}},[_c('v-icon',{staticClass:"accentRed--text mr-2",attrs:{"size":"10"}},[_vm._v("fa-fire")]),_vm._v(" "),_c('span',[_vm._v("\n    "+_vm._s(_vm.isBurned
        ? _vm.$t('components.films.burnCountdownBadge.itemBurned')
        : _vm.$t('components.films.burnCountdownBadge.burningIn', {
            duration: _vm.countdownTimeRemaining,
          }))+"\n  ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }